import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { PageService } from '../../page/page.service'
import { TreevModel } from './treev.model';
import { TreevService } from './treev.service';

@Component({
  selector: 'app-treev',
  templateUrl: './treev.component.html'
})
export class TreevComponent implements OnInit {
  @Input() model: TreevModel
  @Input() dyn: any
  ctyp = 'treev'

  constructor(private pservice: PageService, public service: TreevService) {
    service.components = pservice.components.trvs

  }

  ngOnInit(): void {
    this.pservice.components.trvs.push(this)
  }

  ngAfterViewInit() {
    var thos = this
    if (this.model.codc)
      eval(this.model.codc)
  }
}